import { Audio } from '../../shared/audio';
import { getHighScores } from '../../shared/highScores';
import { getSettings } from '../../shared/settings';
import { createDotsBg, createMenuFloatingShapes } from '../ui/decor';
import { createHighScorePodium, type HighScorePodium } from '../ui/highScorePodium';
import { createGearIcon, createPlayIcon } from '../ui/icons';
import { createMascot, type Mascot } from '../ui/mascot';
import type { Screen, ScreenContext } from './types';

export function createMenuScreen(): Screen {
  let container: HTMLDivElement | null = null;
  let mascot: Mascot | null = null;
  let podium: HighScorePodium | null = null;

  function mount(root: HTMLElement, ctx: ScreenContext): void {
    const settings = getSettings();
    Audio.setSound(settings.sound);
    Audio.setMusic(settings.music);

    container = document.createElement('div');
    container.className = 'menu-screen';
    container.dataset.testid = 'menu-screen';

    container.appendChild(createDotsBg());
    container.appendChild(createMenuFloatingShapes());

    const hero = document.createElement('div');
    hero.className = 'menu-hero';

    mascot = createMascot(15);
    mascot.setMood('cheer');
    mascot.element.classList.add('bob');
    hero.appendChild(mascot.element);

    const titles = document.createElement('div');
    titles.className = 'menu-titles';

    const tagline = document.createElement('div');
    tagline.className = 'menu-tagline headline';
    tagline.textContent = '★ click, pop, press, cheer ★';
    titles.appendChild(tagline);

    const titleMain = document.createElement('h1');
    titleMain.className = 'menu-title-main headline';
    titleMain.textContent = 'POP!';
    titles.appendChild(titleMain);

    const titleSub = document.createElement('h2');
    titleSub.className = 'menu-title-sub headline';
    titleSub.textContent = 'n PRESS!';
    titles.appendChild(titleSub);

    hero.appendChild(titles);
    container.appendChild(hero);

    const actions = document.createElement('div');
    actions.className = 'menu-actions';

    const playBtn = document.createElement('button');
    playBtn.type = 'button';
    playBtn.className = 'chunky-btn teal';
    playBtn.dataset.testid = 'play-btn';
    playBtn.appendChild(createPlayIcon(2));
    const playLabel = document.createElement('span');
    playLabel.textContent = 'NEW GAME';
    playBtn.appendChild(playLabel);
    playBtn.addEventListener('click', () => ctx.goto('game'));

    const settingsBtn = document.createElement('button');
    settingsBtn.type = 'button';
    settingsBtn.className = 'chunky-btn yellow small';
    settingsBtn.dataset.testid = 'settings-btn';
    settingsBtn.appendChild(createGearIcon(1.625));
    const settingsLabel = document.createElement('span');
    settingsLabel.textContent = 'Settings';
    settingsBtn.appendChild(settingsLabel);
    settingsBtn.addEventListener('click', () => ctx.goto('settings'));

    actions.append(playBtn, settingsBtn);
    container.appendChild(actions);

    podium = createHighScorePodium({ scores: getHighScores() });
    if (podium) {
      const wrap = document.createElement('div');
      wrap.className = 'menu-podium-wrap';
      wrap.appendChild(podium.element);
      container.appendChild(wrap);
    }

    const footer = document.createElement('div');
    footer.className = 'menu-footer';
    footer.textContent = 'click circles · press W A S D · have a blast';
    container.appendChild(footer);

    root.appendChild(container);
  }

  function unmount(): void {
    podium?.destroy();
    podium = null;
    mascot?.destroy();
    mascot = null;
    container?.remove();
    container = null;
  }

  return { mount, unmount };
}
